import {
  Divider as DividerParent,
  layers,
  media,
  spacing,
} from '@lamimed/pantheon';
import styled from 'styled-components';

export const LinkProxy = styled.a`
  text-decoration: none;

  ${media.lessThan('tablet')`
    display: block;
    width: 100%;
  `}
`;

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  pointer-events: all;

  ${media.lessThan('tablet')`
    width: 100%;
    z-index: ${layers.menu};
  `};
`;

export const Divider = styled(DividerParent)`
  position: absolute;
  top: -${spacing.xlarge};
  width: 100%;
  z-index: ${layers.menu};
`;
